import { throttle } from "@kluntje/js-utils/lib/function-helpers/decorators";

class ViewportHeightService {
  private rootElement = document.documentElement;

  init() {
    window.addEventListener("resize", () => this.handleResize(), { passive: true });
    this.updateViewportHeight();
  }

  @throttle(100)
  private handleResize() {
    this.updateViewportHeight();
  }

  private updateViewportHeight() {
    this.rootElement.style.setProperty("--wec-viewport-height", `${window.innerHeight}px`);
  }
}

export default new ViewportHeightService();
